import React from 'react';
import Reveal from '../lib/Reveal.jsx';
import KnowledgeGraph from './KnowledgeGraph.jsx';
import { track } from '../lib/analytics.js';

export default function Hero({ tweaks }) {
  const dividerLabel = tweaks.sectionDividers === 'numbered' ? '00 / Index' :
                       tweaks.sectionDividers === 'plain' ? 'Jishutech' : 'Index';
  return (
    <section id="top" style={{ padding: '88px 32px 96px', position: 'relative', zIndex: 1, overflow: 'visible' }}>
      <KnowledgeGraph />
      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <Reveal>
          <div style={{
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            paddingBottom: 28, borderBottom: '1px solid var(--ink-12)',
            fontFamily: 'var(--font-mono)', fontSize: 12, letterSpacing: '0.08em',
            color: 'var(--ink-60)', textTransform: 'uppercase',
          }}>
            <span>{dividerLabel}</span>
            <span style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <span className="pill"><span className="pill-dot live"></span>Currently engaging — 2026</span>
            </span>
          </div>
        </Reveal>

        {tweaks.heroTreatment === 'typographic' && (
          <Reveal style={{ marginTop: 64 }}>
            <h1 style={{
              fontFamily: 'var(--font-display)',
              fontSize: 'clamp(56px, 9vw, 132px)',
              fontWeight: 400, lineHeight: 0.96, letterSpacing: '-0.035em',
              margin: 0, textWrap: 'balance', maxWidth: '14ch',
            }}>
              Applied AI<span style={{ color: 'var(--clay)' }}>,</span><br />
              <span style={{ fontStyle: 'italic', fontWeight: 300 }}>built for</span> finance.
            </h1>
          </Reveal>
        )}

        {tweaks.heroTreatment === 'mark' && (
          <Reveal className="mobile-hero-grid" style={{ marginTop: 64, display: 'grid', gridTemplateColumns: '1fr auto', gap: 48, alignItems: 'end' }}>
            <h1 style={{
              fontFamily: 'var(--font-display)',
              fontSize: 'clamp(48px, 7.6vw, 108px)',
              fontWeight: 400, lineHeight: 0.98, letterSpacing: '-0.03em',
              margin: 0, textWrap: 'balance', maxWidth: '15ch',
            }}>
              A research foundation for <span style={{ fontStyle: 'italic', color: 'var(--clay)' }}>applied AI</span> in financial services.
            </h1>
            <img src="/jishu-monogram.svg" width="220" height="220" alt="" style={{ opacity: 0.9 }} />
          </Reveal>
        )}

        {tweaks.heroTreatment === 'metric' && (
          <Reveal style={{ marginTop: 64 }}>
            <h1 style={{
              fontFamily: 'var(--font-display)',
              fontSize: 'clamp(48px, 7vw, 96px)',
              fontWeight: 400, lineHeight: 1.0, letterSpacing: '-0.03em',
              margin: 0, textWrap: 'balance', maxWidth: '18ch',
            }}>
              Accelerator and mentoring for fintechs that want growth, not theatre.
            </h1>
          </Reveal>
        )}

        <div className="grid12" style={{ marginTop: 72, alignItems: 'end' }}>
          <Reveal style={{ gridColumn: 'span 5' }}>
            <div className="mono-label" style={{ marginBottom: 16 }}>— What we are</div>
            <p style={{
              fontFamily: 'var(--font-display)',
              fontSize: 22, lineHeight: 1.45, color: 'var(--ink)',
              margin: 0, fontWeight: 400, maxWidth: '36ch',
            }}>
              Jishutech is an accelerator and mentoring practice for fintechs. We take only projects that directly impact business growth — anchored in applied research and emerging technologies.
            </p>
            <div style={{ display: 'flex', gap: 12, marginTop: 32 }}>
              <a href="#contact" className="btn btn-primary" onClick={() => track('cta_click', { where: 'hero' })}>
                Start a project <span style={{ fontFamily: 'var(--font-mono)' }}>→</span>
              </a>
              <a href="#research" className="btn btn-ghost">
                Read the thesis
              </a>
            </div>
          </Reveal>

          <Reveal stagger className="mobile-hero-grid" style={{ gridColumn: '8 / span 5', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
            <Metric n="40+" k="Fintech engagements shipped" />
            <Metric n="10+" k="Open-source repositories" />
            <Metric n="3" k="University research collaborations" />
            <Metric n="9wk" k="Default sprint cadence" />
          </Reveal>
        </div>
      </div>
    </section>
  );
}

function Metric({ n, k }) {
  return (
    <div style={{ borderTop: '1px solid var(--ink-24)', paddingTop: 16 }}>
      <div className="metric" style={{ fontSize: 36, color: 'var(--ink)', letterSpacing: '-0.02em' }}>{n}</div>
      <div style={{ fontSize: 13, color: 'var(--ink-60)', marginTop: 8, lineHeight: 1.4, maxWidth: '22ch' }}>{k}</div>
    </div>
  );
}
